/* Mock data — fallback de DEV pra rodar a tela sem backend.
   Usado pelo RouteManagement quando ?mock=1 está na URL ou quando o
   snapshot da API falha (pra desbloquear desenvolvimento de UI sem
   depender do backend v1 estar de pé).

   Os shapes aqui (HF_TECHS, HF_T?_STOPS, HF_UNROUTED, HF_ROUTES) são
   exatamente o que adapter.js#adaptSnapshot produz a partir do snapshot
   real — qualquer divergência é bug. */

export const HF_TECHS = [
   {
      id: 'T1',
      name: 'Carlos Mendes',
      init: 'CM',
      vehicle: 'Fiorino · 9.5m³',
      plate: 'ABC-1D23',
      c: 'c1',
      status: 'run',
      statusLbl: 'Em rota',
      start: '08:00',
      end: '17:00',
      km: 42,
      util: 78,
      util7: [62, 70, 75, 68, 72, 80, 78],
   },
   {
      id: 'T2',
      name: 'Patrícia Lima',
      init: 'PL',
      vehicle: 'HR · 12m³',
      plate: 'DEF-2E34',
      c: 'c2',
      status: 'run',
      statusLbl: 'Em rota',
      start: '07:30',
      end: '17:30',
      km: 58,
      util: 84,
      util7: [70, 76, 80, 82, 88, 86, 84],
   },
   {
      id: 'T3',
      name: 'Marcos Oliveira',
      init: 'MO',
      vehicle: 'Strada · 5m³',
      plate: 'GHI-3F45',
      c: 'c3',
      status: 'warn',
      statusLbl: 'Atrasado',
      start: '08:00',
      end: '17:00',
      km: 36,
      util: 92,
      util7: [80, 82, 88, 90, 95, 93, 92],
   },
   {
      id: 'T4',
      name: 'Bruna Costa',
      init: 'BC',
      vehicle: 'Daily · 16m³',
      plate: 'JKL-4G56',
      c: 'c4',
      status: 'run',
      statusLbl: 'Em rota',
      start: '08:30',
      end: '18:00',
      km: 71,
      util: 65,
      util7: [55, 60, 58, 64, 68, 62, 65],
   },
   {
      id: 'T5',
      name: 'Ricardo Almeida',
      init: 'RA',
      vehicle: 'Sprinter · 14m³',
      plate: 'MNO-5H67',
      c: 'c5',
      status: 'idle',
      statusLbl: 'Aguardando',
      start: '09:00',
      end: '18:00',
      km: 0,
      util: 0,
      util7: [0, 0, 0, 0, 0, 0, 0],
   },
];

export const HF_T1_STOPS = [
   {
      seq: 1,
      id: 'OS-2901',
      nm: 'Padaria Mestre Pão',
      addr: 'R. Lauro Linhares, 1230',
      svc: 'Higienização',
      dur: 25,
      eta: '08:30',
      status: 'done',
      sla: 'low',
      vol: 'A',
      presence: [
         { kind: 'arrived', t: '08:28', label: 'Chegou no local' },
         { kind: 'on_service', t: '08:30', label: 'Iniciou o serviço' },
         {
            kind: 'executed',
            t: '08:53',
            label: 'Completou o serviço com sucesso',
         },
      ],
      otw: { t: '08:54', label: 'Técnico a caminho' },
   },
   {
      seq: 2,
      id: 'OS-2904',
      nm: 'Mercearia Boa Vista',
      addr: 'R. Capitão Romualdo, 88',
      svc: 'Filtro',
      dur: 18,
      eta: '09:25',
      status: 'done',
      sla: 'low',
      vol: 'B',
      presence: [
         { kind: 'arrived', t: '09:22', label: 'Chegou no local' },
         { kind: 'on_service', t: '09:26', label: 'Iniciou o serviço' },
         {
            kind: 'partial',
            t: '09:42',
            label: 'Completou parcialmente o serviço',
         },
      ],
      otw: { t: '09:44', label: 'Técnico a caminho' },
   },
   {
      seq: 3,
      id: 'OS-2908',
      nm: 'Café Praia',
      addr: 'Av. Beira Mar Norte, 4502',
      svc: 'Manutenção',
      dur: 35,
      eta: '10:30',
      status: 'run',
      sla: 'med',
      vol: 'C',
      presence: [
         { kind: 'arrived', t: '10:28', label: 'Chegou no local' },
         { kind: 'on_service', t: '10:32', label: 'Iniciou o serviço' },
      ],
   },
   {
      seq: 4,
      id: 'OS-2911',
      nm: 'Restaurante Estação',
      addr: 'R. Francisco Tolentino, 720',
      svc: 'Filtro',
      dur: 20,
      eta: '11:30',
      status: 'idle',
      sla: 'high',
      vol: 'D',
   },
   {
      seq: 5,
      id: 'OS-2915',
      nm: 'Pizzaria Don Vito',
      addr: 'R. Esteves Júnior, 215',
      svc: 'Instalação',
      dur: 60,
      eta: '13:00',
      status: 'idle',
      sla: 'med',
      vol: 'B',
   },
   {
      seq: 6,
      id: 'OS-2920',
      nm: 'Confeitaria Doce Lar',
      addr: 'R. Bocaiúva, 1890',
      svc: 'Higienização',
      dur: 30,
      eta: '15:00',
      status: 'idle',
      sla: 'low',
      vol: 'A',
   },
];

// Stops mínimos pros demais técnicos — alinhados com os pinos de cada rota
// (HF_ROUTES). Sem presença/OTW no mock; só o suficiente pro drawer renderizar
// quando o usuário clicar num pino do mapa.
export const HF_T2_STOPS = [
   {
      seq: 1,
      id: 'OS-3001',
      nm: 'Padaria Real Centro',
      addr: 'R. Tenente Silveira, 100',
      svc: 'Filtro',
      dur: 22,
      eta: '08:15',
      status: 'done',
      sla: 'low',
      vol: 'B',
   },
   {
      seq: 2,
      id: 'OS-3005',
      nm: 'Restaurante Tio Beto',
      addr: 'R. Felipe Schmidt, 530',
      svc: 'Manutenção',
      dur: 30,
      eta: '09:00',
      status: 'run',
      sla: 'med',
      vol: 'C',
   },
   {
      seq: 3,
      id: 'OS-3008',
      nm: 'Café Saudade',
      addr: 'R. Anita Garibaldi, 220',
      svc: 'Higienização',
      dur: 25,
      eta: '10:30',
      status: 'idle',
      sla: 'low',
      vol: 'A',
   },
   {
      seq: 4,
      id: 'OS-3012',
      nm: 'Mercado Beira Mar',
      addr: 'Av. Beira Mar Norte, 2200',
      svc: 'Filtro',
      dur: 18,
      eta: '11:30',
      status: 'idle',
      sla: 'high',
      vol: 'D',
   },
   {
      seq: 5,
      id: 'OS-3018',
      nm: 'Doceria da Vila',
      addr: 'R. Bocaiúva, 540',
      svc: 'Instalação',
      dur: 60,
      eta: '13:00',
      status: 'idle',
      sla: 'med',
      vol: 'B',
   },
];

export const HF_T3_STOPS = [
   {
      seq: 1,
      id: 'OS-3101',
      nm: 'Posto Atlântico',
      addr: 'R. Capitão Romualdo, 250',
      svc: 'Manutenção',
      dur: 35,
      eta: '08:30',
      status: 'done',
      sla: 'med',
      vol: 'A',
   },
   {
      seq: 2,
      id: 'OS-3105',
      nm: 'Lanchonete Central',
      addr: 'Av. Mauro Ramos, 180',
      svc: 'Filtro',
      dur: 18,
      eta: '09:30',
      status: 'idle',
      sla: 'high',
      vol: 'C',
   },
   {
      seq: 3,
      id: 'OS-3109',
      nm: 'Padaria Estação',
      addr: 'R. Almirante Lamego, 410',
      svc: 'Higienização',
      dur: 25,
      eta: '10:30',
      status: 'idle',
      sla: 'low',
      vol: 'B',
   },
   {
      seq: 4,
      id: 'OS-3114',
      nm: 'Pizzaria Fiore',
      addr: 'R. Vidal Ramos, 90',
      svc: 'Filtro',
      dur: 20,
      eta: '11:30',
      status: 'idle',
      sla: 'med',
      vol: 'B',
   },
];

export const HF_T4_STOPS = [
   {
      seq: 1,
      id: 'OS-3201',
      nm: 'Hotel Praia Mole',
      addr: 'Av. Beira Mar Norte, 5800',
      svc: 'Higienização',
      dur: 40,
      eta: '08:30',
      status: 'done',
      sla: 'low',
      vol: 'B',
   },
   {
      seq: 2,
      id: 'OS-3205',
      nm: 'Restaurante Atlântico',
      addr: 'R. Conselheiro Mafra, 350',
      svc: 'Manutenção',
      dur: 35,
      eta: '10:00',
      status: 'idle',
      sla: 'high',
      vol: 'D',
   },
   {
      seq: 3,
      id: 'OS-3210',
      nm: 'Cafeteria Lagoa',
      addr: 'R. Esteves Júnior, 105',
      svc: 'Filtro',
      dur: 22,
      eta: '11:30',
      status: 'idle',
      sla: 'med',
      vol: 'C',
   },
];

export const HF_UNROUTED = [
   {
      id: 'OS-2950',
      nm: 'Cantina Italiana',
      addr: 'R. Vidal Ramos, 410',
      svc: 'Filtro',
      sla: 'high',
      win: '10:00–12:00',
   },
   {
      id: 'OS-2954',
      nm: 'Mercado Central',
      addr: 'Av. Mauro Ramos, 1502',
      svc: 'Manutenção',
      sla: 'med',
      win: '08:00–17:00',
   },
   {
      id: 'OS-2961',
      nm: 'Hotel Atlântico',
      addr: 'R. Almirante Lamego, 80',
      svc: 'Higienização',
      sla: 'low',
      win: '14:00–18:00',
   },
   {
      id: 'OS-2967',
      nm: 'Lanchonete Express',
      addr: 'R. Felipe Schmidt, 622',
      svc: 'Filtro',
      sla: 'med',
      win: '09:00–11:30',
   },
   {
      id: 'OS-2972',
      nm: 'Açougue Bom Boi',
      addr: 'R. Conselheiro Mafra, 250',
      svc: 'Instalação',
      sla: 'high',
      win: '08:00–10:00',
   },
];

/* Pinos do mapa por rota — coordenadas em viewBox 1080x720.
   techId liga a rota ao técnico (HF_TECHS), pra clique-no-pino abrir o
   stop correspondente em stopsByTech[techId] usando pin.n como seq. */
export const HF_ROUTES = [
   {
      id: 'r1',
      techId: 'T1',
      color: '#B53636',
      d: 'M 180 200 Q 240 240 290 280 T 380 360 T 460 420 T 560 460 T 640 480',
      pins: [
         { x: 180, y: 200, n: 1, done: true, vol: 'A' },
         { x: 290, y: 280, n: 2, done: true, vol: 'B' },
         { x: 380, y: 360, n: 3, run: true, vol: 'C' },
         { x: 460, y: 420, n: 4, vol: 'D' },
         { x: 560, y: 460, n: 5, vol: 'B' },
         { x: 640, y: 480, n: 6, vol: 'A' },
      ],
   },
   {
      id: 'r2',
      techId: 'T2',
      color: '#2563EB',
      d: 'M 720 180 Q 780 220 820 280 T 880 360 T 920 440 T 870 510',
      pins: [
         { x: 720, y: 180, n: 1, done: true, vol: 'B' },
         { x: 820, y: 280, n: 2, run: true, vol: 'C' },
         { x: 880, y: 360, n: 3, vol: 'A' },
         { x: 920, y: 440, n: 4, vol: 'D' },
         { x: 870, y: 510, n: 5, vol: 'B' },
      ],
   },
   {
      id: 'r3',
      techId: 'T3',
      color: '#16A34A',
      d: 'M 200 480 Q 280 500 360 510 T 460 530 T 540 540',
      pins: [
         { x: 200, y: 480, n: 1, done: true, vol: 'A' },
         { x: 360, y: 510, n: 2, vol: 'C' },
         { x: 460, y: 530, n: 3, vol: 'B' },
         { x: 540, y: 540, n: 4, vol: 'B' },
      ],
   },
   {
      id: 'r4',
      techId: 'T4',
      color: '#7C3AED',
      d: 'M 600 220 Q 650 250 690 300 T 760 380',
      pins: [
         { x: 600, y: 220, n: 1, done: true, vol: 'B' },
         { x: 690, y: 300, n: 2, vol: 'D' },
         { x: 760, y: 380, n: 3, vol: 'C' },
      ],
   },
];

export const HF_UNROUTED_PINS = [
   { x: 320, y: 140 },
   { x: 460, y: 240 },
   { x: 880, y: 600 },
   { x: 200, y: 620 },
   { x: 720, y: 620 },
];

export const HF_LEGEND = [
   { c: '#B53636', name: 'Carlos' },
   { c: '#2563EB', name: 'Patrícia' },
   { c: '#16A34A', name: 'Marcos' },
   { c: '#7C3AED', name: 'Bruna' },
   { c: '#D97706', name: 'Ricardo' },
];
